/**
 * Utilitaire de logging pour la production
 * Les logs sont désactivés en production sauf les erreurs critiques
 */

const isDev = process.env.NODE_ENV === "development";

export const logger = {
  log: (...args: unknown[]) => {
    if (isDev) {
      console.log(...args);
    }
  },

  debug: (...args: unknown[]) => {
    if (isDev) {
      console.debug(...args);
    }
  },

  info: (...args: unknown[]) => {
    if (isDev) {
      console.info(...args);
    }
  },

  warn: (...args: unknown[]) => {
    // Les warnings sont toujours affichés
    console.warn(...args);
  },

  error: (...args: unknown[]) => {
    // Les erreurs sont toujours affichées
    console.error(...args);
  },
};
